import React from 'react'

import { useFolderTerm } from '@sketch/modules-common'
import EmptyState from '../../../shares/components/EmptyStateOld'
import DocumentListEmptyState from '../../../shares/components/DocumentListEmptyState'

const TITLE = 'Trash is empty'

interface TrashListEmptyStateProps {
  search?: string
}

const TrashListEmptyState = ({ search }: TrashListEmptyStateProps) => {
  const folderTerm = useFolderTerm()

  if (search) {
    return (
      <EmptyState
        title={TITLE}
        description={`Documents and ${folderTerm.lower}s in Trash are permanently deleted after 90 days.`}
        search={search}
      />
    )
  }

  return (
    <DocumentListEmptyState
      title={TITLE}
      description={`Move any unwanted documents or ${folderTerm.lower}s here.`}
    />
  )
}

export default TrashListEmptyState
